<label [class.title-error]="(control.errors?.['required'] || control.errors?.['squareBrackets']) && control.touched" *ngIf="displayLabel"
    >{{ 'aumico_annual_report_complementary_report_name' | i18next }}
    <span style="color: var(--red-600, #e02424)">*</span></label
>
<input hamInput [formControl]="control" [placeholder]="placeholder" style="width: 364px" (blur)="onBlur()" />
<span *ngIf="control.errors?.['squareBrackets'] && control.touched" style="color: var(--red-600, #e02424); font-size: 12px;">
    {{ 'aumico_annual_report_complementary_reports_title_no_brackets' | i18next }}
</span>
